/**
 * Central gate for the tenant's annotation mode.
 *
 * Returns one of three values:
 *   - "legacy"     — pre-dual-agent flat surface (categorization / sentiment / NER)
 *   - "dual-agent" — Thematics + Attributes surface (lite / full researcher variants;
 *                    variant lives on `dualAgentConfig.agentMode`)
 *   - "split"      — split-call PM path (signal-discovery C1 + topic-tagging C2,
 *                    followed by post-annotation topic clustering into Findings)
 *
 * Source of truth: `platformConfigs.ai.aiAnnotation.mode`. Split is a distinct
 * top-level surface, not a variant of the dual-agent path. The DB migration
 * that moves split tenants from the pre-refactor shape (mode: "dual-agent" +
 * dualAgentConfig.agentMode: "split") to the new shape (mode: "split") must
 * land BEFORE this code deploys — there is no fallback here.
 *
 * @param {Object} platformConfigs
 * @returns {"legacy" | "dual-agent" | "split"}
 */
export const getAnnoMode = (platformConfigs) => {
  const mode = platformConfigs?.ai?.aiAnnotation?.mode;
  if (mode === "legacy") return "legacy";
  if (mode === "split") return "split";
  if (mode === "dual-agent") return "dual-agent";
  // Nothing set (or unrecognized) — default to dual-agent for safety.
  return "dual-agent";
};
